import React, { useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import BookingComponent from "./../HostIndividual/BookingComponent";
const ViewSubadminPageNew = () => {
  const [Name, setName] = useState("");
  const [Data, setUserData] = useState("");
  const [logintype, setLoginType] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [personname, setPersonName] = useState("");
  const [address, setAddress] = useState("");
  const [joindate, setJoinDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { id } = useParams();
  const isEditMode = !!id;

  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
    const fetchAdminData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/userById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch Host Business data");
        }

        const data = await response.json();
        console.log(data.result.hostBusinessDetails);

        let formattedPhone;
        setUserData(data.result);
        setName(data.result.hostBusinessDetails.businessName || "");
        setEmail(data.result.hostBusinessDetails.businessEmail || "");
        if (data.result.hostBusinessDetails.businessPersonDialCode) {
          formattedPhone =
            data.result.hostBusinessDetails.businessPersonDialCode +
            data.result.hostBusinessDetails.businessPersonContactNo;
        } else {
          if (data.result.hostBusinessDetails.businessPersonContactNo) {
            formattedPhone =
              data.result.hostBusinessDetails.businessPersonContactNo || "";
            const countryCode = formattedPhone.slice(0, 3);
            if (countryCode === "+91") {
              const part1 = formattedPhone.slice(3, 6);
              const part2 = formattedPhone.slice(6, 9);
              const part3 = formattedPhone.slice(9);
              formattedPhone = `${countryCode} (${part1}) ${part2}-${part3}`;
            } else {
              const cc = formattedPhone.slice(0, 2);
              const ac = formattedPhone.slice(2, 5);
              const mid = formattedPhone.slice(5, 8);
              const last = formattedPhone.slice(8);
              formattedPhone = `${cc}(${ac}) ${mid}-${last}`;
            }
          }
        }

        const date = new Date(data.result.createdAt);
        if (!isNaN(date)) {
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = String(date.getFullYear());

          const formattedDate = `${day}-${month}-${year}`;

          setJoinDate(formattedDate);
        } else {
          console.error("Invalid date format:", data.result.createdAt);
          setJoinDate("Invalid Date");
        }
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear());

        const formattedDate = `${day}-${month}-${year}`;

        setLoginType(
          data.result.loginType?.charAt(0).toUpperCase() +
            data.result.loginType?.slice(1) || ""
        );
        setPhone(formattedPhone || "");
        setPersonName(
          (data.result.hostBusinessDetails.businessPersonFirstName || "") +
            " " +
            (data.result.hostBusinessDetails.businessPersonLastName || "")
        );
        setAddress(data.result.hostBusinessDetails.businessAddress || "");
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [isEditMode, id, navigate]);
  const fetchBookingData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/booking-list-by-renter-host?hostId=${id}`;
    try {
      setLoading(true);
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(API_ENDPOINT, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch booking data");
      }

      const data = await response.json();
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    if (loading) return <Loader />;
  }

  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Personal Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24"
                  id="pills-change-passwork-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-change-passwork"
                  type="button"
                  role="tab"
                  aria-controls="pills-change-passwork"
                  aria-selected="false"
                  tabIndex={-1}
                >
                  Booking/Payment history
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <form action="#">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Name</b>
                        </span>
                        <p> {Name}</p>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Phone Number</b>
                        </span>
                        <p> {phone}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Email</b>
                        </span>

                        <p> {email}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Person </b>
                        </span>

                        <p> {personname}</p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Join Date </b>
                        </span>

                        <p>{joindate}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Business Address </b>
                        </span>

                        <p> {address}</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <span>
                          <b>Signup By</b>
                        </span>
                        <p> {logintype}</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <BookingComponent bookingData="hostbusiness"></BookingComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSubadminPageNew;
